import { render, staticRenderFns } from "./LicenseSearchInput.vue?vue&type=template&id=19ab1344&scoped=true"
import script from "./LicenseSearchInput.vue?vue&type=script&lang=ts"
export * from "./LicenseSearchInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ab1344",
  null
  
)

export default component.exports